<template lang="pug">
  .service-list-notification.pb-4
    .table-view-header
      h3 Creación de notificaciones
      .table-view-header-actions
        b-button(v-b-modal.create-notification-modal size="sm" variant="secondary") + Nuevo
    b-table(:fields="tableFields" :items="tableItems" head-row-variant="light-primary" responsive)
      template(v-slot:cell(message)="{value}")
        div(style="min-width: 300px") {{value}}
      template(v-slot:cell(Acciones)="{item}")
        .table-actions
          b-button(@click="openEditModal(item)" size="sm", variant="light" style="color: #7F828F")
            font-awesome-icon(:icon="['far', 'edit']" size="lg")
          b-button(@click="removeNotification(item.id)" size="sm", variant="light" style="color: #7F828F")
            font-awesome-icon(:icon="['far', 'trash-alt']" size="lg")
    //- Modals
    b-modal#create-notification-modal(title="Crear notificación" ref="create-notification-modal" size="lg" hide-footer)
      create-edit-form(
        :serviceId="service.id"
        @done="hideModal('create-notification-modal')"
        @cancel="$refs['create-notification-modal'].hide()"
      )
    b-modal(title="Editar notificación" ref="edit-notification-modal" size="lg" hide-footer)
      create-edit-form(
        :notification="selectedNotification"
        :serviceId="service.id"
        @done="hideModal('edit-notification-modal')"
        @cancel="$refs['edit-notification-modal'].hide()"
        editMode
      )
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import CreateEditForm from './CreateEditForm'

export default {
  components: {
    CreateEditForm
  },
  data () {
    return {
      selectedNotification: null,
      tableFields: [
        {
          key: 'day',
          label: 'Día',
          sortable: true,
        },
        {
          key: 'subject',
          label: 'Asunto',
          sortable: true
        },
        {
          key: 'message',
          label: 'Mensaje',
          sortable: true
        },
        'Acciones'
      ]
    }
  },
  methods: {
    ...mapActions(['getService', 'deleteServiceNotification']),
    hideModal (modalRef) {
      this.$refs[modalRef].hide()
      this.getService(this.service.id)
    },
    openEditModal (notification) {
      this.selectedNotification = notification
      this.$refs['edit-notification-modal'].show()
    },
    async removeNotification (notificationId){
      const modalMsg = '¿Está seguro que desea eliminar esta notificación?'
      const modalOptions = {
        title: 'Eliminar notificación',
        okTitle: 'Eliminar',
        okVariant: 'danger'
      }
      const confirmed = await this.$bvModal.msgBoxConfirm(modalMsg, modalOptions)
      if (confirmed) {
        const response = await this.deleteServiceNotification({ serviceId: this.service.id, notificationId })
        if (response.status >= 200 && response.status < 300) {
          this.$bvToast.toast('La notificación se eliminó correctamente', {
            title: 'Éxito!',
            variant: 'success'
          })
        } else {
          this.$bvToast.toast('No se pudo eliminar la  notificación', {
            title: 'Oops!',
            variant: 'danger'
          })
        }
        this.getService(this.service.id)
      }
    }
  },
  computed: {
    ...mapGetters(['service']),
    tableItems () {
      return [...this.service.notifications]
    }
  }
}
</script>
